// components/ui/Button.js — single button primitive, four variants
// All buttons in the app should use this. Variants:
//   primary   — filled accent. Use for the ONE primary action per surface.
//   secondary — bordered. Use for adjacent actions of equal weight.
//   ghost     — text-only. Use for tertiary nav, back links, muted dismissals.
//   danger    — destructive action (delete, abandon, force-quit). Use sparingly.
import React from 'react';
import { Link } from 'react-router-dom';

const VARIANTS = {
  primary:   'bg-accent hover:bg-accent-hover text-[var(--on-accent)]',
  secondary: 'border border-line-strong hover:border-faint text-read bg-surface',
  ghost:     'text-mutedink hover:text-ink',
  danger:    'bg-status-bad hover:bg-status-bad text-white',
};

const SIZES = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-sm',
  lg: 'px-5 py-2.5 text-base',
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  to,
  href,
  onClick,
  type = 'button',
  disabled = false,
  className = '',
  ...rest
}) {
  const base = 'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed';
  const cls = `${base} ${VARIANTS[variant]} ${SIZES[size]} ${className}`;

  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...rest}>{children}</a>;
  return (
    <button type={type} onClick={onClick} disabled={disabled} className={cls} {...rest}>
      {children}
    </button>
  );
}
